export default __webpack_public_path__ + "static/media/FeeIcon.f07134f7.svg";